import React from 'react'
import { node, string, oneOf } from 'prop-types'
import classnames from 'classnames'

const SectionContainer = ({
  className: classNameProp,
  marginTop,
  marginBottom,
  paddingTop,
  paddingBottom,
  backgroundColor,
  component,
  children,
  ...otherProps
}) => {
  const className = classnames(
    'campus-section',
    classNameProp
  )
  const Component = component

  const mobileSize = (num) => {
    switch (num) {
      case 120:
        return 80
      case 80:
        return 64
      case 0:
        return 0
      default:
        return 64
    }
  }

  return (
    <Component className={className} {...otherProps}>
      { children }

      <style jsx>
        {`
          .campus-section {
            margin-top: ${mobileSize(marginTop)}px;
            margin-bottom: ${mobileSize(marginBottom)}px;
            padding-top: ${mobileSize(paddingTop)}px;
            padding-bottom: ${mobileSize(paddingBottom)}px;
            background-color: ${backgroundColor};
            @media screen and (min-width: 768px) {
              margin-top: ${marginTop}px;
              margin-bottom: ${marginBottom}px;
              padding-top: ${paddingTop}px;
              padding-bottom: ${paddingBottom}px;
            }
          }
        `}
      </style>
    </Component>
  )
}

SectionContainer.propTypes = {
  marginTop: oneOf([0, 80, 120]),
  marginBottom: oneOf([0, 80, 120]),
  paddingTop: oneOf([0, 80, 120]),
  paddingBottom: oneOf([0, 80, 120]),
  backgroundColor: string,
  component: oneOf(['div', 'section']),
  children: node,
}

SectionContainer.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
  paddingTop: 0,
  paddingBottom: 0,
  backgroundColor: '#fff',
  component: 'div',
}

export default SectionContainer
